// src/components/bot/questions/PhoneQuestion.tsx
// 🎨 PHONE QUESTION COMPONENT - For phone number input
// ✅ UPDATED: Removed placeholder, countryCode fields and false validation claims

import React from 'react';
import BaseQuestion from './BaseQuestion';
import styles from './Questions.module.css';
import { QuestionItem } from '../hooks/useBotForm';
import logger from '../../../utils/logger';

interface PhoneQuestionProps {
  question: QuestionItem;
  index: number;
  onUpdate: (id: string, field: keyof QuestionItem, value: any) => void;
  onRemove: (id: string) => void;
  onMoveUp: () => void;
  onMoveDown: () => void;
  canMoveUp: boolean;
  canMoveDown: boolean;
  forceCollapsed?: boolean;
}

const PhoneQuestion: React.FC<PhoneQuestionProps> = (props) => {
  const { question } = props;

  logger.log('📱 PhoneQuestion: Rendering simplified phone question:', question.id);

  // ❌ REMOVED: countryCodes array - no longer needed

  return (
    <BaseQuestion {...props}>
      
      {/* ❌ REMOVED: typeSpecificOptions section - no more placeholder/countryCode fields */}
      {/* ❌ REMOVED: validationInfo section with false validation claims */}

      {/* 🎯 PHONE QUESTION PREVIEW - Simplified */}
      <div className={styles.questionPreview}>
        <div className={styles.previewLabel}>Preview:</div>
        <div className={styles.previewContent}>
          <div className={styles.previewQuestion}>
            {question.question || 'Enter your question above...'}
            {question.required && <span className={styles.requiredAsterisk}>*</span>}
          </div>
          <div className={styles.previewInput}>
            <input 
              type="tel"
              placeholder="+1 234 567 8900"
              disabled
              className={styles.previewInputField}
            />
          </div>
        </div>
      </div>
      
    </BaseQuestion>
  );
};

export default PhoneQuestion;